import React from "react";
import { Row, Col, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { ShoppingCart, TrendingUp, Clipboard, PieChart, Book, File as Rocket } from "react-feather";

const categoryColors = {
  "Room Service & POS Reports": "#20c997",
};

const roomServiceReports = [
  {
    category: "Room Service & POS Reports",
    reports: [
      { icon: <ShoppingCart />, title: "Daily Sales Report", description: "Summarizes daily sales revenue from room service and POS.", link: "/reports/daily-sales" },
      { icon: <TrendingUp />, title: "Sales Analytics Report", description: "Detailed sales trend analysis over time.", link: "/reports/sales-analytics" },
      { icon: <Clipboard />, title: "Daily Item Wise Sales", description: "Tracks itemized sales per day.", link: "/reports/item-wise-sales" },
      { icon: <PieChart />, title: "Item Wise Analytics", description: "Insightful analytics for best and worst-performing items.", link: "/reports/item-analytics" },
      { icon: <Book />, title: "Tax Reports", description: "Tracks tax collected from room service and POS transactions.", link: "/reports/tax-reports" },
    ],
  },
];

const quickLinks = [
  { icon: <ShoppingCart />, title: "Daily Sales Report", link: "/reports/daily-sales", category: "Room Service & POS Reports" },
  { icon: <PieChart />, title: "Item Wise Analytics", link: "/reports/item-analytics", category: "Room Service & POS Reports" },
  { icon: <Book />, title: "Tax Reports", link: "/reports/tax-reports", category: "Room Service & POS Reports" },
];

const RoomServiceReports = ({ searchQuery }) => {
  const navigate = useNavigate();

  const handleCardClick = (link) => {
    navigate(link);
  };

  const filteredReports = roomServiceReports.map((category) => ({
    ...category,
    reports: category.reports.filter(
      (report) =>
        report.title.toLowerCase().includes(searchQuery) ||
        report.description.toLowerCase().includes(searchQuery)
    ),
  })).filter((category) => category.reports.length > 0);

  const filteredQuickLinks = quickLinks.filter(
    (link) =>
      link.title.toLowerCase().includes(searchQuery) ||
      link.category.toLowerCase().includes(searchQuery)
  );

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={18} lg={20}>
        {filteredReports.map((category, index) => (
          <div key={index} className="category-section mb-4">
            <h4
              className="category-title"
              style={{
                color: "#031b4e",
                fontSize: "20px",
                fontWeight: "400",
                marginBottom: "20px",
                display: "inline-block",
                borderBottom: `3px solid ${categoryColors[category.category]}`,
                paddingBottom: "5px",
              }}
            >
              {category.category}
            </h4>
            <Row gutter={[16, 16]}>
              {category.reports.map((report, idx) => (
                <Col key={idx} xs={24} sm={12} md={12} lg={8}>
                  <Card
                    hoverable
                    style={{
                      borderLeft: `4px solid ${categoryColors[category.category]}`,
                      cursor: "pointer",
                      borderRadius: "8px",
                    }}
                    onClick={() => handleCardClick(report.link)}
                  >
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                      <div
                        style={{ 
                          color: categoryColors[category.category], 
                          fontSize: "24px", 
                          marginRight: "16px",
                          flexShrink: 0 
                        }}
                      >
                        {report.icon}
                      </div>
                      <div>
                        <h5 style={{ fontSize: "16px", fontWeight: "600", margin: "0 0 8px" }}>{report.title}</h5>
                        <p style={{ fontSize: "14px", color: "#666", margin: 0 }}>{report.description}</p>
                      </div>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        ))}
      </Col>
      <Col xs={24} md={6} lg={4} style={{ paddingRight: 0 }}>
        <div
          style={{
            backgroundColor: "#f8f9fa",
            padding: "16px",
            borderRadius: "8px 0 8px 8px",
            borderLeft: "4px solid #007bff",
            minHeight: "100%",
          }}
        >
          <h4
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#031b4e",
              marginBottom: "16px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Rocket size={18} style={{ marginRight: "8px", color: "#007bff" }} />
            Quick Links
          </h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {filteredQuickLinks.map((link, idx) => (
              <li
                key={idx}
                onClick={() => handleCardClick(link.link)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px",
                  marginBottom: "4px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                }}
                className="quick-link-item"
              >
                <span
                  style={{
                    color: categoryColors[link.category],
                    marginRight: "8px",
                    fontSize: "16px",
                  }}
                >
                  {link.icon}
                </span>
                <span style={{ fontSize: "14px", color: "#333" }}>{link.title}</span>
              </li>
            ))}
          </ul>
        </div>
      </Col>
    </Row>
  );
};

export default RoomServiceReports;